// features/cart/components/cart-item-skeleton.tsx
import { Skeleton } from "@/components/ui/skeleton"

export function CartItemSkeleton() {
  return (
    <div className="flex items-start space-x-3 py-3">
      {/* Quantity Stepper Placeholder */}
      <div className="flex flex-col items-center space-y-1">
        <Skeleton className="size-5 rounded-full" />
        <Skeleton className="h-4 w-4" />
        <Skeleton className="size-5 rounded-full" />
      </div>

      {/* Image Placeholder */}
      <Skeleton className="size-16 rounded-md shrink-0" />

      {/* Text Details Placeholder */}
      <div className="flex-1 space-y-2">
        <Skeleton className="h-5 w-3/4" /> {/* Item Name */}
        <Skeleton className="h-4 w-1/2" /> {/* Note Placeholder (optional) */}
        <Skeleton className="h-4 w-1/4" /> {/* Price */}
      </div>

      {/* Remove Button Placeholder */}
      <Skeleton className="size-6 rounded-full shrink-0" />
    </div>
  )
}
